import React, { useState } from 'react';
import { SlDrawer } from '@shoelace-style/shoelace/dist/react';
import ChatContent from './ChatContent';
import AdDetailsContent from './AdDetailsContent';
const DefaultContent = () => (
    <div>
        <p>Empty drawer content.</p>
    </div>
);

const ContentDrawer = ({ isOpen, type, rowData, onClose }) => {
    if (!isOpen) return null;

    const renderContent = () => {
        switch (type) {
            case 'chat':
                return <ChatContent data={rowData}/>;
            case 'adDetails':
                return <AdDetailsContent adData={rowData} />;
            default:
                return <DefaultContent />;
        }
    };


    return (
        <SlDrawer
            open={isOpen}
            onSlAfterHide={onClose}
            style={{ '--size': type === 'chat' ? '600px' : '1200px' }}
            className="h-screen"
        >
            <label slot="label" className="flex justify-between items-center w-full">
                <div className="flex flex-col">
                    <h4 className="text-lg font-semibold">{rowData.brand}</h4>
                    <span className="text-sm text-gray-500">{rowData.adType}</span>
                </div>
            </label>
            <div className="p-2 h-[calc(100vh-80px)] overflow-y-auto">
                {renderContent()}
            </div>
        </SlDrawer>
    );
};

export default ContentDrawer; 